import WalmartLabs from "./WalmartLabs";
import SI_99ROOMZ from "./99roomz";
import KEC_INTERNATIONAL from "./KEC_International";
import AIISC from "./AIISC";
import Cars24 from "./Cars24";
import EcomExpress from "./EcomExpress";
import Zomato from "./Zomato";
import BITS_Project from "./BITS_Project";
import "./workexp.css";

function WorkExp() {
  return (
    <div>
      <div className="workexp" id="workexp">
        <h1>Work Experience</h1>
        <Zomato />
        <EcomExpress />
        <Cars24 />
        <AIISC />
        <WalmartLabs />
        <SI_99ROOMZ />
        <KEC_INTERNATIONAL />
        <h1>College Projects</h1>
        <BITS_Project />
      </div>
    </div>
  );
}

export default WorkExp;
